<div
  [ngStyle]="{
    'padding-bottom':
      detailType !== 'updateJob'
        ? apidataUpdation === true && !offlineMode
          ? '150px'
          : '80px'
        : '0px',
  }"
  id="updateEventList"
>
  <!-- scan check points BEGIN -->
  @if (detailType === "scanCheckPoint") {
    <div class="mb-1">
      @if (dupCheckpointList?.length == 0) {
        <div class="alert alert-primary fw-bold my-3 text-center">
          No Checkpoints Near You
        </div>
      }
      @if (dupCheckpointList.length > 0) {
        <div>
          <div class="flex-grow-1 mb-3">
            <div class="input-group">
              @if (!distanceCalculation) {
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control"
                    id="searchCheckpoints"
                    placeholder="Search Checkpoints"
                    [(ngModel)]="searchFilter"
                    (input)="onCPFilterApply($event)"
                  />
                  <label for="searchCheckpoints">Search Checkpoints</label>
                </div>
              }
              @if (searchFilter) {
                <span class="input-group-text" (click)="onCPClearFilter()">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
          @if (nearestCheckPointsList?.length == 0) {
            <div class="alert alert-primary fw-bold my-3 text-center">
              No Records Match Your Search Criteria
            </div>
          }
          <div class="row">
            @for (checkPoint of nearestCheckPointsList; track checkPoint) {
              <div class="gy-2" (click)="openScanCheckpointCamera(checkPoint)">
                <div class="gt-card p-2">
                  <div class="fw-bold">
                    {{ checkPoint?.name }}
                  </div>
                  <div class="small">
                    @if (checkPoint?.site_name) {
                      <div>
                        {{ checkPoint?.site_name }} [{{ checkPoint?.company }}]
                      </div>
                    } @else {
                      <div>
                        {{ checkPoint?.company }}
                      </div>
                    }
                    <div>
                      {{ checkPoint?.partial_address }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <!-- scan check points ENDS -->

  <!-- nearestJob list section start -->
  @if (detailType === "updateJob") {
    <div>
      @if (apidataUpdation === true && !offlineMode) {
        <div
          class="alert alert-primary my-2 d-flex justify-content-between align-items-center"
        >
          <div class="fw-bold">Fetching Data from Server</div>
          <div class="spinner-grow" role="status"></div>
        </div>
      }
      @if (dupnearestJobList?.length == 0 && !apidataUpdation && isGuardUser) {
        <div class="my-2">
          @if (!offlineMode) {
            <button
              class="btn btn-outline-primary btn-lg btn-block w-100 mb-2 d-none"
              routerLink="/roster"
            >
              View Roster
            </button>
          }
          <div
            class="alert alert-light text-center border-start-0 border-end-0 rounded-0 d-flex align-items-center justify-content-center"
          >
            Nothing Rostered Today
            @if (!offlineMode) {
              <span routerLink="/roster" class="ms-2">
                <i class="fa-regular fa-window-restore fs-2"></i>
              </span>
            }
          </div>
        </div>
      }
      <!-- NEW CARDS FOR WORKER TIMETABLE -->
      @if (dupnearestJobList?.length) {
        <div id="assigned-jobs-area" class="p-2">
          <div class="mb-2">
            <dt>Assigned Jobs</dt>
          </div>
          <div class="small">
            @for (
              job of showFilteredJobsAlso ? dupnearestJobList : nearestJobList;
              track job
            ) {
              <div>
                <div
                  (click)="openEventPage(job)"
                  class="border mb-2 rounded gt-card"
                  [ngClass]="{
                    'active-runsheet border-primary':
                      job?.job_type_key === -1 &&
                      (job | misc: 'isInProgressCheck'),
                    'opacity-50':
                      job?.job_type_key === -1 &&
                      !(job | misc: 'isInProgressCheck'),
                  }"
                >
                  <div class="d-flex gap-3">
                    @if (job?.schedule_details?.start_time) {
                      <div class="fw-semibold">
                        {{
                          job?.schedule_details?.start_time
                            | misc: "formatStartEndTime"
                        }}
                      </div>
                    }
                    <div class="flex-grow-1">
                      <div class="d-flex">
                        <div
                          class="flex-grow-1"
                          [ngClass]="job?.job_type_key == 0 ? '' : 'opacity-75'"
                        >
                          <span
                            [ngClass]="
                              job?.job_type_key == 0
                                ? 'text-danger fw-semibold'
                                : ''
                            "
                          >
                            {{
                              job?.job_type_key == 4
                                ? "Patrol Route"
                                : job?.job_type_name
                            }}
                            @if (job?.response_type_name) {
                              <span> - {{ job.response_type_name }} </span>
                            }
                          </span>
                        </div>
                        @if (job?.status_name) {
                          <div
                            [ngStyle]="
                              job?.status_name
                                | misc: 'getJobStatusStyle' : statusData
                            "
                          >
                            {{ job?.status_name }}
                          </div>
                        }
                        @if (
                          job?.checkpoints && job?.checkpoints_remaining == 0
                        ) {
                          <!-- checkpoint patrols-->
                          <div class="bg-success text-white completed-status">
                            Complete
                          </div>
                        }
                        @if (
                          job?.job_type_key === -1 &&
                          job?.additional_info?.task_stats?.total_tasks &&
                          job?.additional_info?.task_stats?.completed_tasks ==
                            job?.additional_info?.task_stats?.total_tasks
                        ) {
                          <!-- runsheets-->
                          <div class="bg-success text-white completed-status">
                            Complete
                          </div>
                          <!-- @if (job?.additional_info?.has_assignee_clocked_out) {
                            <div class="bg-success text-white completed-status">
                              Complete
                            </div>
                          } @else {
                            <div class="bg-warning text-dark completed-status">
                              Pending Clock Out
                            </div>
                          } -->
                        }
                        @if (
                          job?.job_type_key === -1 &&
                          job?.additional_info?.task_stats?.total_tasks &&
                          job?.additional_info?.task_stats?.completed_tasks !=
                            job?.additional_info?.task_stats?.total_tasks &&
                          (job?.schedule_details
                            | misc: "runsheetDueDateTimeHomePage")
                        ) {
                          <div>
                            <div>
                              <span
                                >{{
                                  (job?.schedule_details
                                    | misc: "runsheetDueDateTimeHomePage")?.[0]
                                    ? "Ended"
                                    : "Due"
                                }}
                              </span>
                              <span class="fw-semibold mx-1">{{
                                (job?.schedule_details
                                  | misc: "runsheetDueDateTimeHomePage")?.[1]
                              }}</span>
                            </div>
                          </div>
                        }
                      </div>
                      <div>
                        <span class="fw-semibold">
                          {{ job?.site_name }}
                        </span>
                        @if (job?.company_name) {
                          <span>[{{ job?.company_name }}]</span>
                        }
                      </div>
                      @if (job?.checkpoints) {
                        <div>
                          @if (job?.checkpoints_remaining) {
                            Scanned:
                            {{ job?.checkpoints - job?.checkpoints_remaining }}
                            of
                            {{ job?.checkpoints }}
                          }
                        </div>
                      }
                      @if (
                        job?.job_type_key === -1 &&
                        job?.additional_info?.task_stats?.total_tasks &&
                        job?.additional_info?.task_stats?.completed_tasks !=
                          job?.additional_info?.task_stats?.total_tasks
                      ) {
                        <div>
                          <span class="opacity-75">Tasks Remaining: </span>
                          <span class="fw-bold">
                            {{
                              job?.additional_info?.task_stats?.total_tasks -
                                job?.additional_info?.task_stats
                                  ?.completed_tasks
                            }}</span
                          >
                        </div>
                      }
                      <div>
                        {{ job?.site_address }}
                      </div>
                    </div>
                  </div>
                  @if (
                    eventAdditionalInfo?.runsheet_next_tasks?.[job?.event_id]
                      ?.task_id &&
                    job?.job_type_key === -1 &&
                    job?.additional_info?.task_stats?.total_tasks &&
                    job?.additional_info?.task_stats?.completed_tasks !=
                      job?.additional_info?.task_stats?.total_tasks
                  ) {
                    <div
                      class="rounded border bg-secondary-subtle p-2 my-1 gt-multi-line text-dark small-font"
                    >
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          {{
                            eventAdditionalInfo?.runsheet_next_tasks?.[
                              job?.event_id
                            ]?.task
                          }}
                        </div>
                        <div>
                          <button class="btn btn-success btn-sm">
                            <i class="fa-solid fa-check"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          @if (shiftsAfter12pm?.length && !showFilteredJobsAlso) {
            <div class="text-center mb-2">
              <button
                class="btn btn-outline-primary"
                (click)="showFilteredJobsAlso = true"
              >
                Show Jobs after 12pm
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
  <!-- nearestJob List end -->

  <!-- Nearest Site List BEGIN -->
  @if (
    ["addSitePhoto", "addSiteComment", "userPromptInfo"].includes(detailType)
  ) {
    <div>
      @if (dupnearestSiteList.length === 0) {
        <div class="alert alert-primary fw-bold my-3 text-center">
          No Sites Near You
        </div>
      }
      @if (dupnearestSiteList.length > 0) {
        <div class="col-12 col-md-6 col-lg-5">
          <div class="alert alert-primary mb-2">Select Site</div>
          <div class="input-group mb-2">
            @if (!distanceCalculation) {
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  id="filterResults"
                  placeholder="Filter Sites"
                  [(ngModel)]="searchFilter"
                  (input)="onFilterSitesApply($event)"
                />
                <label for="filterResults">Filter Sites</label>
              </div>
            }
            @if (searchFilter) {
              <span class="input-group-text" (click)="onClearSitesFilter()">
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
          @if (nearestSiteList?.length == 0) {
            <div class="alert alert-primary fw-bold my-3 text-center">
              No Records Match Your Search Criteria
            </div>
          }
          <div class="row">
            @for (item of nearestSiteList; track item) {
              <div class="gy-2 cursor-pointer" (click)="updateSite(item)">
                <div class="gt-card p-4">
                  @if (item?.site_id) {
                    <div class="fw-semibold">{{ item?.site_name }}</div>
                    <div>{{ item?.company_name }}</div>
                    <div class="small-font text-secondary">
                      {{ item?.site_address }}
                    </div>
                  } @else {
                    <div class="fw-semibold">{{ item?.company_name }}</div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <!-- Nearest Site List END -->
</div>
@if (detailType !== "updateJob") {
  <div class="bottom-section" id="fixedBtn">
    <div class="mx-2 mb-3 pt-2">
      @if (apidataUpdation === true && !offlineMode) {
        <div
          class="alert alert-primary my-2 d-flex justify-content-between align-items-center"
        >
          <div class="fw-bold">Fetching Data from Server</div>
          <div class="spinner-grow" role="status"></div>
        </div>
      }
      <button class="btn btn-dark btn-lg w-100 d-lg-none" (click)="goBack()">
        Back
      </button>
    </div>
  </div>
}

<ng-template #commentRef let-commentRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Add a Comment
      <span (click)="commentRef.close('close')" class="float-end">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!--api returns an empty sites list-->
    @if (!apidataUpdation && !nearestSiteList?.length) {
      <div>
        <div class="alert alert-warning">No sites found near you</div>
        <div class="col">
          <button
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close('close')"
          >
            Back
          </button>
        </div>
      </div>
    }
    @if (apidataUpdation || (!apidataUpdation && nearestSiteList?.length)) {
      <div>
        <div class="form-group input-group col mb-2">
          <textarea
            class="form-control"
            rows="5"
            wrap="hard"
            maxlength="340"
            [disabled]="
              !apidataUpdation && !nearestSiteList?.length ? true : false
            "
            placeholder="Enter comment here"
            autofocus
            [(ngModel)]="newComment"
            id="updateCommentBox"
          ></textarea>
          @if (newComment) {
            <span
              class="input-group-text"
              (click)="clearAndFocusTextBox('updateCommentBox')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
        @if (groupUserCount > 1) {
          <div class="mb-4">
            <label for="handLog">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="handOverLogDraft"
                (change)="handOverLogDraft = !handOverLogDraft"
                id="handLog"
              />
              Include in handover log</label
            >
          </div>
        }
        <div class="row row-cols-2">
          <div class="col">
            <button
              class="btn btn-dark btn-lg w-100"
              (click)="commentRef.close('close')"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newComment"
              (click)="commentRef.close()"
            >
              Add Comment
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>
